function GreyCircleIcon({ className = '' }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`text-text-secondary transition-colors duration-300 ${className}`}
    >
      <circle
        cx="9"
        cy="9"
        r="8.5"
        fill="white"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default GreyCircleIcon;
